import { put, call } from "redux-saga/effects";
import { exceptionHandler } from "../pages/common/functions";
import { releaseNotificationConstants } from "../actions/constants/releaseNotificationConstant";
import ReleaseNotificationService from "../services/api/releaseNotificationService";

function* releaseNotificationGetSetting(request: any) {
	try {
		const result = yield call(
			ReleaseNotificationService.releaseNotificationGetSetting,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: releaseNotificationConstants.ReleaseNotificationSettingGetSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: releaseNotificationConstants.ReleaseNotificationSettingGetFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: releaseNotificationConstants.ReleaseNotificationSettingGetFailure,
			payload: error,
		});
	}
}

function* releaseNotificationUpdateSetting(request: any) {
	try {
		const result = yield call(
			ReleaseNotificationService.releaseNotificationUpdateSetting,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: releaseNotificationConstants.ReleaseNotificationSettingUpdateSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: releaseNotificationConstants.ReleaseNotificationSettingUpdateFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: releaseNotificationConstants.ReleaseNotificationSettingUpdateFailure,
			payload: error,
		});
	}
}

export const releaseNotificationSaga = {
	releaseNotificationGetSetting,
	releaseNotificationUpdateSetting
};
